import React, { useState, useEffect } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import filterFactory, {
  textFilter,
  selectFilter,
} from "react-bootstrap-table2-filter";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit";
// import cellEditFactory from "react-bootstrap-table2-editor";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import { toast } from "react-toastify";

// Import Service
import factoryService from "../../services/factory.service";
import authService from "../../services/auth.service";
import farmerService from "../../services/farmer.service";

//Import Loading
import Spinner from "react-bootstrap/Spinner";
// import { confirmAlert } from "react-confirm-alert";
// import LoadingAlert from "../../components/LoadingAlert";

// Import Modal
// import ModalViewDetail from "./modalViewMembers";
import ModalAddFactory from "./modalAddFactory";
import ModalEditFactory from "./modalEditFactory";
import ModalCheckFactoryMember from "./modalCheckFactoryMember";
import MemberForm from "./formMember";

//Import tooltip
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

import "./factory.css";

const Factorylist = () => {
  const [loading, setLoading] = useState(true);
  // const [loadingAlert, setLoadingAlert] = useState(false);
  // const [show_view, setShow_view] = useState(false);
  const [show_add, setShow_add] = useState(false);
  const [show_edit, setShow_edit] = useState(false);
  // const [data_select, setData_select] = useState(0);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [user_id, setUser_id] = useState(0);
  const [showFormCheck, setShowFormCheck] = useState(false);
  const [showMemberForm, setShowMemberForm] = useState(false);
  const [farmer, setFarmer] = useState({});
  const [factory, setFactory] = useState({});

  const { SearchBar } = Search;
  const { ExportCSVButton } = CSVExport;

  const user = authService.getCurrentUser();
  useEffect(() => {
    getData();
    // getFactory();
    // setLoading(false);
  }, []);

  const getFarmer = (farmer_idcard) => {
    farmerService.getFarmerById(farmer_idcard).then((response) => {
      setFarmer(response.data.farmer);
    });
  };

  // const getFactory = (factory_id) => {
  //   factoryService.getFactoryById(factory_id).then((response) => {
  //     setFactory(response.data.data);
  //     console.log(response.data.data);
  //   });
  // };

  const getData = () => {
    factoryService
      .getFactorylist()
      .then((response) => {
        setData(response.data.data);
      })
      .catch((error) => {
        console.error("error fetching data: ", error);
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // const clickAddMember = (form) => {
  //   getFarmer(form.search);
  //   getFactory(form.assoc);
  //   setShowFormCheck(false);
  //   setShowMemberForm(true);

  //   // alert(JSON.stringify(form));
  // };

  // const onSubmitSave = (e) => {
  //   const fromdata = {
  //     ...e,
  //     factory_id: user.user.user_assoc,
  //     user_id: user.user.user_id,
  //   };
  //   setLoading(true);
  //   factoryService
  //     .createNewFactory(fromdata)
  //     .then((response) => {
  //       console.log(response.data.data);
  //       setData([response.data.data, ...data]);
  //     })
  //     .catch((error) => {
  //       console.error("error add data: ", error);
  //       setError(error);
  //     })
  //     .finally(() => {
  //       setLoading(false);
  //       setShowMemberForm(false);
  //     });
  // };

  const onSubmitFoctorySave = (e) => {
    const fromdata = {
      ...e,
    };
    setLoading(true);
    console.log(fromdata);
    factoryService
      .createFactory(fromdata)
      .then((response) => {
        console.log(response.data.data);
        setData([response.data.data, ...data]);
      })
      .catch((error) => {
        console.error("error add data: ", error);
        setError(error);
      })
      .finally(() => {
        setLoading(false);
        setShow_add(false);
      });
  };

  const onSubmitMemberSave = (e) => {
    const formdata = {
      ...e,
      // assocId: user.user.user_assoc ? user.user.user_assoc : e.assocId,
      user_id: user.user.user_id,
    };
    // console.log(formdata);
    setLoading(true);
    factoryService
      .createMember(formdata)
      .then((response) => {
        console.log(response.data);
        if (response.data.success) {
          setData([response.data.data, ...data]);
          // console.log(data);
        }
      })
      .catch((error) => {
        console.error("error add data: ", error);
        setError(error);
      })
      .finally(() => {
        setLoading(false);
        setShowMemberForm(false);
      });
  };

  const handleClickAdd = () => {
    setShow_add(true);
  };

  // const clickCheckMember = (row) => {
  //   console.log("clickCheckMember");
  //   console.log(row);
  //   setFactory(row);
  //   setShowFormCheck(true);
  // };

  const clickAddMember = (form) => {
    getFarmer(form.search);
    // getAssociation(form.assoc);
    setShowFormCheck(false);
    setShowMemberForm(true);

    // alert(JSON.stringify(form));
  };

  const clickViewData = (row) => {
    console.log("View");
    setFactory(row);
    // setShow_view(true);
    console.log(factory);
  };

  const ActionsView = (row) => {
    return (
      <>
        <i
          className="bi bi-search custom-icon-table"
          onClick={() => clickViewData(row.row)}
        ></i>
      </>
    );
  };

  const clickEdit = (row) => {
    console.log("Edit");
    // getFactory(row.factoryId);
    setFactory(row);
    // setfactory_id(id);
    console.log(row);
    setUser_id(user.user.user_id);
    setShow_edit(true);
  };

  const ActionsEdit = (row) => {
    return (
      <>
        {/* <i
          className="text-success bi bi-person-plus custom-icon-table"
          onClick={() => clickCheckMember(row.row)}
        ></i> */}
        <i
          className="bi bi-pencil custom-icon-table"
          onClick={() => clickEdit(row.row)}
        ></i>
        {/* {parseInt(row.row.members.replace(/,/g, "")) == 0 ? ( */}
        {/* <i
          className="bi bi-trash custom-icon-table"
          onClick={() => clickDeleteFactory(row.row)}
          style={{ color: "red" }}
          title="ลบข้อมูลสมาคม"
        ></i> */}
        {/* ) : (
          ""
        )} */}
      </>
    );
  };

  // const clickDeleteFactory = (row) => {
  //   console.log(row);
  //   confirmAlert({
  //     title: "",
  //     message: "ต้องการลบใช่หรือไม่",
  //     buttons: [
  //       {
  //         label: "ใช่",
  //         onClick: () => {
  //           factoryService
  //             .deleteFactory(row.factoryId)
  //             .then((response) => {
  //               if (response.data.success) {
  //                 setData((data) =>
  //                   data.filter((a) => a.factoryId != row.factoryId)
  //                 );
  //               }
  //             })
  //             .catch((error) => {
  //               console.error("error fetching data: ", error);
  //               setError(error);
  //             })
  //             .finally(() => {
  //               setLoading(false);
  //             });
  //         },
  //       },
  //       {
  //         label: "ไม่ใช่",
  //         onClick: () => false,
  //       },
  //     ],
  //     overlayClassName: "confirm-alert-2button",
  //   });
  // };

  const actionsViewFormatter = (cell, row) => {
    if (user.user.member_type !== 5) {
      return <ActionsEdit row={row} />;
    } else {
      return <ActionsView row={row} />;
    }
  };

  const showCSVButton = (prop) => {
    if (user.user.member_type === 5) {
      return (
        <ExportCSVButton
          {...prop.csvProps}
          style={{
            padding: ".375rem .75rem",
            fontSize: "1rem",
            float: "right",
          }}
        >
          <i className="bi bi-download"></i>
        </ExportCSVButton>
      );
    } else if (user.user.member_type === 6) {
      return (
        <button
          className="btn btn-primary"
          onClick={handleClickAdd}
          style={{
            padding: ".375rem .75rem",
            fontSize: "1rem",
            float: "right",
          }}
        >
          เพิ่มโรงงาน
        </button>
      );
    }
  };

  // const filterActive = (cell) => {
  //   if (cell == 1) {
  //     return (
  //       <i className="text-success bi bi-person-plus custom-icon-table"></i>
  //     );
  //   } else {
  //     return (
  //       <i className="text-danger bi bi-person-plus custom-icon-table"></i>
  //     );
  //   }
  // };

  const filterActive = {
    1: "ใช้งาน",
    0: "ยกเลิก",
  };

  const changeStatus = (body) => {
    console.log(body);
    factoryService
      .activateFactory(body)
      .then((res) => {
        if (res.data.success) {
          // toast.success(res.data.message);
          toast.success("แก้ไขเรียบร้อย !!", {
            position: "bottom-left",
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => toast.error(err));
  };

  const renderTooltip = (props) =>
    user.user.member_type === 6 ? (
      <Tooltip {...props}>คลิ๊กเพื่อแก้ไขสถานะ</Tooltip>
    ) : (
      <span></span>
    );

  const formatActive = (cell) => {
    if (cell == 1) {
      return (
        <OverlayTrigger placement="top" overlay={renderTooltip}>
          <p className="text-success">ใช้งาน</p>
        </OverlayTrigger>
      );
    } else {
      return (
        <OverlayTrigger placement="top" overlay={renderTooltip}>
          <p className="text-danger">ยกเลิก</p>
        </OverlayTrigger>
      );
    }
  };

  // const filterRegions = {
  //   1: "กลาง",
  //   2: "เหนือ",
  //   3: "ตะวันออกเฉียงเหนือ",
  //   4: "ตะวันออก",
  //   "-": "ไม่ระบุ",
  // };

  // const optionRegions = [
  //   { value: "1", label: "กลาง" },
  //   { value: "2", label: "เหนือ" },
  //   { value: "3", label: "ตะวันออกเฉียงเหนือ" },
  //   { value: "4", label: "ตะวันออก" },
  //   { value: "", label: "ไม่ระบุ" },
  // ];

  const headerSortingStyle = {
    backgroundColor: "#D4EFDF",
    verticalAlign: "center",
  };

  const columns = [
    {
      text: "factoryId",
      dataField: "factoryId",
      sort: true,
      // filter: textFilter({ placeholder: "ค้นหา" }),
      hidden: true,
    },
    {
      text: "สถานะ",
      formatter: formatActive,
      // formatter: (cell) => filterActive[cell],
      filter: selectFilter({
        placeholder: "เลือก",
        style: { fontSize: "98%", width: "100%" },
        options: filterActive,
      }),
      dataField: "factoryStatus",
      sort: true,
      editable: user.user.member_type === 6 ? true : false,
      editor: {
        type: Type.SELECT,
        options: [
          { value: "1", label: "ใช้งาน" },
          { value: "0", label: "ยกเลิก" },
        ],
        style: { placeholder: "select", fontSize: "98%" },
      },
      headerSortingStyle,
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      text: "รหัสโรงงาน",
      filter: textFilter({
        placeholder: "ค้นหา",
        style: { fontSize: "98%", width: "100%" },
      }),
      dataField: "factoryCode",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      headerSortingStyle,
    },
    {
      text: "ชื่อโรงงาน",
      filter: textFilter({
        placeholder: "ค้นหา",
        style: { fontSize: "98%", width: "100%" },
      }),
      dataField: "factoryName",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "30%" };
      },
      headerSortingStyle,
      style: {
        textAlign: "left",
      },
    },
    {
      text: "ที่อยู่",
      filter: textFilter({
        placeholder: "ค้นหา",
        style: { fontSize: "98%", width: "100%" },
      }),
      dataField: "factoryAddress",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "40%" };
      },
      headerSortingStyle,
      style: {
        textAlign: "left",
      },
    },
    {
      text: "แก้ไข",
      dataField: "edit",
      isDummyField: true,
      editable: false,
      formatter: actionsViewFormatter,
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      headerSortingStyle,
    },
  ];

  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 10,
    firstPageText: "|<",
    lastPageText: ">|",
    nextPageText: ">>",
    prePageText: "<<",
    showTotal: true,
    alwaysShowAllBtns: true,
    onPageChange: (page, sizePerPage) => {
      console.log("page", page);
      console.log("sizePage", sizePerPage);
    },
    onSizePerPageChange: (page, sizePerPage) => {
      console.log("page", page);
      console.log("sizePage", sizePerPage);
    },
  });

  if (loading) return <Spinner animation="border" variant="success" />;
  if (error) return `Error :${error}`;

  return (
    <div>
      {/* {loadingAlert ? <LoadingAlert /> : ""} */}
      {/* {JSON.stringify(data)} */}
      {/* <ModalViewDetail
        show={show_view}
        data={factory}
        setdata={(b) => setData(b)}
        hidden={(a) => setShow_view(a)}
      /> */}
      <ModalCheckFactoryMember
        show={showFormCheck}
        hidefunc={(a) => setShowFormCheck(a)}
        onClickAdd={clickAddMember}
        factorydata={factory}
      />
      <MemberForm
        show={showMemberForm}
        hidden_func={(a) => setShowMemberForm(a)}
        farmerdata={farmer}
        factorydata={factory}
        onsubmit={onSubmitMemberSave}
      />
      <ModalAddFactory
        show={show_add}
        data={data}
        setdata={(b) => setData(b)}
        hidden={(a) => setShow_add(a)}
        onsubmit={onSubmitFoctorySave}
      />
      <ModalEditFactory
        show={show_edit}
        hidden={(a) => setShow_edit(a)}
        data={factory}
        factorydata={data}
        setdata={(b) => setData(b)}
        userid={user_id}
      />
      <ToolkitProvider
        bootstrap4
        keyField="factoryId"
        data={data}
        columns={columns}
        search
        exportCSV={{
          fileName: "factory.csv",
          separator: ",",
          ignoreHeader: false,
          noAutoBOM: true,
          blobType: "text/csv;charset=UTF-8",
          // blobType: "text/csv;charset=ansi",
          onlyExportFiltered: true,
          exportAll: false,
        }}
      >
        {(prop) => (
          <React.Fragment>
            <div>
              <div className="text-left">
                <SearchBar {...prop.searchProps} placeholder="ค้นหา" />
                {showCSVButton(prop)}
              </div>
            </div>
            <hr />
            <BootstrapTable
              pagination={pagination}
              keyField="factory_id"
              data={data}
              columns={columns}
              loading={true}
              filter={filterFactory()}
              // headerClasses="header-class"
              {...prop.baseProps}
              cellEdit={cellEditFactory({
                mode: "click",
                blurToSave: true,
                afterSaveCell: (oldValue, newValue, row, column) => {
                  changeStatus({
                    factoryid: row.factoryId,
                    factorystatus: newValue,
                  });
                  console.log(oldValue);
                  console.log(newValue);
                  console.log(row);
                  console.log(column);
                  console.log("After Saving Cell!! ");
                },
              })}
            />
          </React.Fragment>
        )}
      </ToolkitProvider>
    </div>
  );
};

export default Factorylist;
